import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import theme from '../styles/theme';

const AudioIcon = ({ classes, className, muted }) => (
  <div className={cn(className, classes.audioIcon, { on: !muted })}>
    <span />
    <span />
    <span />
  </div>
);

AudioIcon.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  className: PropTypes.string,
  muted: PropTypes.bool,
};

AudioIcon.defaultProps = {
  className: undefined,
  muted: true,
};

export default injectSheet({
  audioIcon: {
    margin: [0, 1, 0, 7],
    paddingBottom: 2,
    position: 'relative',
    display: 'flex',
    alignItems: 'flex-end',
    '& > span': {
      width: 2,
      height: 6,
      display: 'inline-block',
      margin: [0, 6, 0, 0],
      backgroundColor: theme.colors.white,
      lineHeight: 23,
      transition: 'height 0.15s ease-in-out',
    },
    '&.on > span': {
      '&:nth-child(1)': {
        height: 10,
      },
      '&:nth-child(2)': {
        height: 16,
      },
      '&:nth-child(3)': {
        height: 21,
      },
    },
  },
})(AudioIcon);
